import { MenuItem } from "@mui/material";
import { Tag } from "lucide-react";
import { useState } from "react";
import MarkAsSoldModal from "../mark-as-sold";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

export default function MarkAsSoldMenuItem({
  listingUid,
}: {
  listingUid: string;
}) {
  const [open, setOpen] = useState(false);

  const { readonly } = useReadonlyContext();
  return (
    <>
      <MenuItem
      disabled={readonly}
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
          color: theme.nawy.colors.semantic.text.extension.negative,
        })}
        onClick={() => setOpen(true)}
      >
        <Tag />
        Mark as sold
      </MenuItem>
      <MarkAsSoldModal open={open} setOpen={setOpen} listingUid={listingUid} />
    </>
  );
}
